export default {
  lockedPromoCodeOfferFillColor: Styles.color.primary,
  textTransform: 'capitalize',
  expiresPrefix: 'Expires',
};
